import React from "react";
import { View } from '../../../components/templates/View';
import { CDContacto, CMContacto } from '../organisms';
import { useViewport } from "../../../hooks";

const Contacto = () => {

    const { width } = useViewport();

    return(
        width > 850 ?
            <>
                <View children={ <CDContacto />} />
            </>
        :
            <>
                <View children={ <CMContacto />} />
            </>
    );
}

export default Contacto;